<template>
  
  <div class="chartAcorda">
      <div class="chartItemTitulo">Controle Remoto</div>
    <div class="chartItemIcone" id="iconeAcordachart">
      <i class="fas fa-power-off"></i>
    </div>
    <div class="chartItemValor" id="valorAcordachart">Acordar Bateria</div>
    <div class="chartItemSubValor">Entrou em modo Sleep<br>07/02/2020 - 18:19h</div>
  </div>

</template>

<script>

export default {
    name: 'ChartAcorda'
}
</script>

<style>
.chartAcorda {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
#iconeAcordachart {
  color: green;
  margin-top: 20px
}
#valorAcordachart {
  text-shadow: 2px 2px #000;
  font-size: 2.5em;
  margin-top: 20px;
}
</style>